import { render, staticRenderFns } from "./productsResults.vue?vue&type=template&id=f3c44dd0"
import script from "./productsResults.vue?vue&type=script&lang=js"
export * from "./productsResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports